import React, { useState, useRef } from "react"
import { useLocation, useNavigate } from "react-router-dom"
import ReactCrop from "react-image-crop"
import "react-image-crop/dist/ReactCrop.css"
import "bootstrap/dist/css/bootstrap.min.css"
import { toast } from "react-toastify"
import { uploadImageRequest } from "store/Common/Actions"
import { useDispatch } from "react-redux"
const CropPage = () => {
  const location = useLocation()
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const imageUrl = location.state?.imageUrl
  const Uid = location.state?.Uid
  const [loading, setLoading] = useState(false)

  const [crop, setCrop] = useState({
    unit: "px", // Set unit to pixels
    width: 200, // Fixed width
    height: 200, // Fixed height
    aspect: 1,
  })

  const [completedCrop, setCompletedCrop] = useState(null)

  const imgRef = useRef(null)
  const canvasRef = useRef(null)

  const generateCroppedImage = async () => {
    if (!imgRef.current || !completedCrop) return null

    const image = imgRef.current
    const canvas = canvasRef.current
    const ctx = canvas.getContext("2d")

    const scaleX = image.naturalWidth / image.width
    const scaleY = image.naturalHeight / image.height

    canvas.width = completedCrop.width
    canvas.height = completedCrop.height

    ctx.drawImage(
      image,
      completedCrop.x * scaleX,
      completedCrop.y * scaleY,
      completedCrop.width * scaleX,
      completedCrop.height * scaleY,
      0,
      0,
      completedCrop.width,
      completedCrop.height
    )

    return canvas.toDataURL("image/jpeg")
  }

  return (
    <div className="page-content">
      <div className="container d-flex flex-column align-items-center">
        <div className="card shadow-lg p-2 w-100" style={{ maxWidth: "100%" }}>
          {imageUrl && (
            <>
              <div className="border p-3 rounded">
                <ReactCrop
                  crop={crop}
                  onChange={newCrop => setCrop(newCrop)}
                  onComplete={c => setCompletedCrop(c)}
                  aspect={1}
                >
                  <img
                    ref={imgRef}
                    src={imageUrl}
                    alt="To Crop"
                    className="img-fluid rounded"
                  />
                </ReactCrop>
              </div>

              <button
                onClick={async () => {
                  setLoading(true)

                  try {
                    const croppedImage = await generateCroppedImage()
                    if (croppedImage) {
                      dispatch(uploadImageRequest(Uid, croppedImage, navigate))
                    } else {
                      toast.error("Failed to generate cropped image.")
                    }
                  } catch (error) {
                    console.error("Error generating image:", error)
                  } finally {
                    setLoading(false)
                  }
                }}
                className="btn btn-success px-4 shadow"
                disabled={loading}
              >
                {loading ? "Processing..." : "Upload"}
              </button>
              <button
                  onClick={() => navigate(-1)}
                  className="btn btn-danger px-4 shadow mt-2"
                >
                  Cancel
                </button>

              <canvas ref={canvasRef} style={{ display: "none" }} />
            </>
          )}
        </div>
      </div>
    </div>
  )
}

export default CropPage
